try{self['workbox:cacheable-response:4.1.1']&&_()}catch(e){}// eslint-disable-line